import styled from 'styled-components';
import {Box} from "@mui/material";


export const StyledBoxWrapper = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex-shrink: 0;
    width: 100%;
    padding: 16px;
    border-radius: 16px;
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    word-break: break-word;
    background: ${({theme}) => theme.palette.background.paper};
`;

export const StyledDigitizationPage = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;

interface MainContainerProps {
    $row?: boolean;
}

export const StyledDigitizationCard = styled.div<MainContainerProps>`
    display: flex;
    flex: 1;
    flex-direction: ${({$row}) => $row ? 'row' : 'column'};
    min-height: 0;
    overflow: auto;
    
    border-radius: 32px;
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    background: ${({theme}) => theme.palette.background.paper};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
`;

export const StyledDigitizationContent = styled.div`
    display: flex;
    background: ${({theme}) => theme.palette.background.dropzone};
    border-top: 1px solid ${({theme}) => theme.palette.dividers.light};
    flex: 1;
    align-items: flex-start;
    justify-content: center;
    padding: 16px 32px 28px;
    gap: 16px;
    min-height: 0;
    overflow: hidden;
`;

export const StyledFilePreviewWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 3;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    background-color: inherit;
`;